let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("8oQx9")).then(() => parcelRequire('2TyBm'));